import React from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useLocation, Link as RouterLink } from "react-router-dom";

const Breadcrumb = ({ pathMap = {} }) => {
    const location = useLocation();
    const pathNames = location.pathname.split("/").filter((x) => x);
    const { domain: domain, next: current, prev: previous } = location.state || {};

    return (
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 3 }}>
            <Link
                component={RouterLink}
                to="/"
                underline="hover"
                color="inherit"
            >
                Home
            </Link>
            { !location.state && pathNames.map((value, index) => {
                const to = `/${pathNames.slice(0, index + 1).join("/")}`;
                const isLast = index === pathNames.length - 1;
                const displayName = ((!!pathMap[value] ? pathMap[value] : '') || decodeURIComponent(value))
                    .replace(/^\w/, (c) => c.toUpperCase());
                return isLast ? (
                    <Typography key={to} color="text.primary">
                        {displayName}
                    </Typography>
                ) : (
                    <Link
                        key={to}
                        component={RouterLink}
                        to={to}
                        underline="hover"
                        color="inherit"
                    >
                        {displayName}
                    </Link>
                );
            })}
            {
                domain && 
                    <Link
                        component={RouterLink}
                        to="/Products"
                        underline="hover"
                        color="inherit"
                    >
                        Products
                    </Link>
            }
            {
                previous &&
                    <Link
                        component={RouterLink}
                        to={`/Products/${previous.id}`}
                        underline="hover"
                        color="inherit"
                    >
                        {previous.name}
                    </Link>
            }
            {
                current &&
                    <Typography color="text.primary">
                        {current.name}
                    </Typography>
            }
        </Breadcrumbs>
    );
};

export default Breadcrumb;
